export default __webpack_public_path__ + "static/casper-association-logo-bc8e08d2dff85061f3886b2f24d9f22d.svg";